module.exports = __webpack_public_path__ + "static/media/boy-1.30811cc5.svg";